export enum FileUploadType {
  CHALLENGE_HEADER = 'challengeHeader',
  CHALLENGE_LISTING = 'challengeListing',
  CHALLENGE_ATTACHMENT = 'challengeAttachment',
  PAGE_HEADER = 'pageHeader'
}
